import React ,{useEffect ,useState} from 'react'
import { db } from '../firebase'
import {onSnapshot ,collection ,query,limit} from "firebase/firestore"
import Card from '../component/ui/Card';
import Loader from '../component/ui/Visual-utilities/Loader';
import d19 from './Notifications.module.css'

function Notifications() {
    const NotifCollRef=collection(db,'notifications')
    const [notifications, setNotifications ]= useState([]);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {//called immidiately when the page loads
      setIsLoading(true);
        try{const q = query(NotifCollRef,limit(10));
        
        const getNotif=()=>{ 
          onSnapshot(q , 
            snapshot => { setNotifications(snapshot.docs.map(doc => doc.data( )))
              setIsLoading(false);  }
        ); } 
       getNotif();
       console.log(notifications)
       }
       catch(e){console.log(e)}
       },[])

    return (
       <div>
           
           {isLoading &&  <Loader/>}
            {notifications.length===0 && 'no Notifications yet'}
            
              
            { notifications.map(  (n,index)=> {
               return <Card key={index}>
                 <div className={d19.notifContainer} >
                      <p className={d19.notifTitle}>{n.title}</p>
                      <p className={d19.notifContent}>{n.content}</p>
                      <p className={d19.notifTime}>{n.createdAt?n.createdAt.toDate().toString().substring(0,21):null}</p>
                </div>
                </Card>
                
                         }  )}
        </div>
    )
}

export default Notifications
